module.exports = __webpack_public_path__ + "img/IM.60368cfd.svg";